/**
 * chat-thread — 句子切分（**純函數**；Node 可直接 import → `scripts/ui-smoke.mjs` 真測）
 *
 * 為何要（`decisions/026`）：must-use 唔再限於輸入框 —— 用戶要可以喺**自己嘅訊息逐句撳**。
 *   ⚠️ 唔用「長按拖選」：手機拖選係系統 UI，web 冇可靠 API 讀跨節點選取。
 */
export function splitSentences(text: string, maxLen = 40): string[] {
  const clean = text.replace(/\r\n/g, "\n").trim();
  if (!clean) return [];
  const parts = clean
    .split(/(?<=[。！？；，、!?;,.\n])/)
    .map((s) => s.trim())
    .filter(Boolean);
  const out: string[] = [];
  for (const p of parts) {
    if (p.length <= maxLen) {
      out.push(p);
      continue;
    }
    for (let i = 0; i < p.length; i += maxLen) out.push(p.slice(i, i + maxLen));
  }
  return out.slice(0, 40);
}
